// extracted by css-extract-rspack-plugin
export default {"spinner-container":"spinner-container-lQvjuT","spinnerContainer":"spinner-container-lQvjuT"};